import { withTheme, css } from '@emotion/react'
import styled from '@emotion/styled'
import {
  Autocomplete,
  Popper,
  autocompleteClasses,
  inputClasses,
  formControlClasses,
} from '@mui/material'
import { colors } from '@global/constants'

const PADDING_WITH_BORDER = 3

export const StyledAutocomplete = withTheme(
  styled(Autocomplete)(
    (props: any) =>
      ({
        [`& .${autocompleteClasses.popper}`]: {
          width: `${props.theme.width - PADDING_WITH_BORDER * 2}px`,
        },
        [`& .${autocompleteClasses.root}`]: {
          zIndex: '1',
          backgroundColor: '#fff',
        },
        [`& .${autocompleteClasses.paper}`]: {
          borderRadius: 0,
          borderColor: `${colors.blue.smokey} !important`,
          boxShadow: props.theme.misc.shadow.boxShadow,
        },
        [`& .${inputClasses.root}`]: {
          height: `${props.theme.height - PADDING_WITH_BORDER * 2}px`,
          width: `calc(100% - ${PADDING_WITH_BORDER * 2}px)`,
          overflow: 'hidden',
          position: 'relative',
          zIndex: '1',
          backgroundColor: '#fff',
        },
        [`& .${inputClasses.root}:before`]: {
          borderBottom: 'none !important',
        },
        [`& .${inputClasses.root}:after`]: {
          borderBottom: 'none !important',
        },
        [`& .${formControlClasses.root}`]: {
          padding: `${PADDING_WITH_BORDER}px`,
          width: `calc(100% - ${PADDING_WITH_BORDER * 2 + PADDING_WITH_BORDER}px)`,
          overflow: 'hidden',
        },
      }) as any,
  ),
)

export const StyledAutocompletePopper = withTheme(
  styled(Popper)(({ theme }: any) => ({
    zIndex: 9999,
    [`& .${autocompleteClasses.paper}`]: {
      width: `${theme.width}px`,
    },
  })),
)

export const MenuListRow = css`
  padding: 0 15px 0 0;
  cursor: pointer;
  list-style: none;
  display: flex;
  align-items: center;
  font-size: 12px;

  &:hover {
    background-color: ${colors.blue.aliceBlue};
  }

  &.-is-selected {
    background-color: ${colors.blue.aliceBlue};
  }
`

const popperBase = 'multi-select-autocomplete-popper'

export const Global = css({
  [`.${popperBase} .MuiAutocomplete-option`]: MenuListRow,
})
